<template>
  <v-container
    class="d-flex align-start justify-center pt-16"
    style="min-height: 100vh"
  >
    <v-card width="500" class="mx-auto pa-6" style="border: 2px solid #2ab3b8">
      <div class="text-center mb-8">
        <h1 class="text-h3 mb-4" style="color: #2ab3b8">Dynamic Insights</h1>
        <p class="text-subtitle-1 text-medium-emphasis">
          Choose how you'd like to sign in to access your account.
        </p>
      </div>

      <div class="d-flex flex-column align-center gap-4">
        <v-btn
          block
          variant="outlined"
          @click="signIn('google')"
          :loading="loading"
          height="48"
          class="login-btn"
        >
          <v-icon start color="#DB4437">mdi-google</v-icon>
          Continue with Google
        </v-btn>

        <v-btn
          block
          variant="outlined"
          @click="signIn('microsoft')"
          :loading="loading"
          height="48"
          class="login-btn"
        >
          <v-icon start color="#0078D4">mdi-microsoft</v-icon>
          Continue with Microsoft
        </v-btn>

        <v-btn
          block
          variant="outlined"
          @click="signIn('linkedin')"
          :loading="loading"
          height="48"
          class="login-btn"
        >
          <v-icon start color="#0A66C2">mdi-linkedin</v-icon>
          Continue with LinkedIn
        </v-btn>
      </div>

      <v-alert v-if="error" type="error" variant="tonal" class="mt-4">
        {{ error }}
      </v-alert>
    </v-card>
  </v-container>
</template>

<script>
import AuthService from "@/services/AuthService";

export default {
  name: "LoginView",
  data: () => ({
    loading: false,
    error: null,
  }),
  methods: {
    async signIn(provider) {
      this.loading = true;
      this.error = null;
      AuthService.signIn(provider);
    },
  },
};
</script>

<style scoped>
.error-message {
  color: #ff5252;
  font-size: 0.875rem;
}

.login-btn {
  background-color: white !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  font-weight: 400 !important;
  font-size: 16px !important;
}

:deep(.v-btn__content) {
  justify-content: flex-start;
  padding: 0 16px;
}

:deep(.v-input__control) {
  height: 48px;
}

.login-btn {
  margin-bottom: 16px;
}
</style>
